<template>
  <div
    class="sf-block"
    :class="{'hidden' : hidden,
       'clickable': clickable}"
    :style="[background === 'default' ? {} : {  'background-image': 'url(' + background + ')' }]">

    <component
      :is="clickable ? 'router-link' : 'div'"
      @click="clickHandler"
      :to="link != null ? link : ''">
      <div class="sf-block-content">
        <div v-if="title" class="title" v-html="title"></div>
        <img v-if="icon" class="logo" :src="icon" :class="{'xl-icon' : bigIcon}" alt="">
        <div v-if="subtitle" class="subtitle" v-html="subtitle"></div>
      </div>
    </component>
  </div>
</template>
<script>
export default {
  name: 'SFBlock',
  props: {
    link: {
      type: Object,
      default: undefined,
    },
    click: {
      type: Function,
      default: undefined,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    background: {
      type: String,
      default: 'default',
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    bigIcon: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clickHandler() {
      if (this.click !== undefined) {
        this.click();
      }
    },
  },
};
</script>
